import axios from 'axios';
import { BASE_URL } from '../../services/fetch';
export const signIn = (phoneNumber, password) => {
  return axios
    .post(BASE_URL + 'api/auth/signin', {
      phoneNumber: phoneNumber,
      password: password,
    })
    .then(({ data: token }) => {
      localStorage.setItem('token', token);
    });
};
